export const COMBAT = {
  GOLD_MIN:        5,     // randomGold()'s default range when a monster doesn't override it
  GOLD_MAX:        20,
  HUNT_RANGE:      48,   // px (3 tiles) — proximity to prompt/resolve a hunt
  CRIT_CHANCE:     0.2,
  CRIT_MULTIPLIER: 1.8,
  DAMAGE_VARIANCE: 0.2,  // +/- 20% roll on outgoing damage
  AI_INTERVAL_MS:  3000, // monster moves every 3s
  RESPAWN_MS:      10000, // respawn 10s after death
  MONSTER_MIN_TILES: 1,
  MONSTER_MAX_TILES: 3,
} as const;
